import { createContext, useContext, useEffect, useState } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [googleUser, setGoogleUser] = useState(() => {
    const stored = sessionStorage.getItem("googleUser");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (googleUser) {
      sessionStorage.setItem("googleUser", JSON.stringify(googleUser));
    } else {
      sessionStorage.removeItem("googleUser");
    }
  }, [googleUser]);

  return (
    <UserContext.Provider value={{ googleUser, setGoogleUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
